module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp1_9005.d1fbbff5.png";